import React, { useState, useEffect, useCallback, useLayoutEffect } from 'react';
import { useProjectState, setProjectState } from '@starflow/app/store';
import { GeneratorPanel as LegacyGeneratorPanel } from './_legacy';
import { Prompt as LegacyPrompt } from './_legacy/prompt';
import { RecommendThemeList as LegacyRecommendThemeList } from './_legacy/RecommendThemeList';
import FlowFold from '@starflow/app/components/flow/components/FlowFold';
import cs from 'classnames';

export { GenerationInfoPanel } from './_legacy/info';
export { GeneratorElements } from './Element';
export { wrapImageOverlayer } from './Overlayer';

const GeneratorPanelInner = React.memo(({ nodeId }) => {
  const node = useProjectState((state) => state.nodeMap[nodeId]);

  if (!node) return null;

  return <LegacyGeneratorPanel generator={node.data} />;
});

export const GeneratorPanel = () => {
  const currentNodeId = useProjectState('currentNodeId');

  if (!currentNodeId) return null;

  const nodeType = currentNodeId.split('-')[1];

  if (nodeType !== 'generator') return null;

  return <GeneratorPanelInner nodeId={currentNodeId} />;
};

export const PromptPanel = React.memo(() => {
  const currentNodeId = useProjectState('currentNodeId');
  const isFoldFlow = useProjectState('isFoldFlow');
  const [isShowFlowEntry, setIsShowFlowEntry] = useState(false);
  const node = useProjectState((state) => state.nodeMap[currentNodeId]);
  const [showRecommendThemeList, setShowRecommendThemeList] = useState(false);

  const ref = document.getElementById('generator-prompt-container');
  const { height } = ref?.getBoundingClientRect() ?? 183;
  const flowFlodHeight = React.useMemo(() => {
    const h = height ?? 130;
    return showRecommendThemeList ? `${h + 50}px` : `${h}px`;
  }, [showRecommendThemeList, height]);

  useEffect(() => {
    const localFlag = localStorage.getItem('__HIDDEN_PROMPT_THEME_RECOMMENDATION_FLAG___');
    if (localFlag !== '1') {
      setShowRecommendThemeList(true);
    }
  }, []);

  useLayoutEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const flow = params.get('flow');
    if (flow) {
      setIsShowFlowEntry(true);
    }
  }, []);

  const handleClosePromptGuide = useCallback(() => {
    setShowRecommendThemeList(false);
  }, []);

  if (!currentNodeId) return null;

  const nodeType = currentNodeId.split('-')[1];

  const flag = isFoldFlow && isShowFlowEntry;

  if (nodeType !== 'generator') {
    return (
      <div className={cs('flex pointer-events-auto', flag ? 'p-3' : '')}>
        {flag && (
          <div
            className={cs('w-[164px] flex-shrink-0 rounded border bg-white mr-2')}
            style={{ height: flowFlodHeight }}
          >
            <FlowFold />
          </div>
        )}
      </div>
    );
  } else {
    if (!node) return null;
    return (
      <div className={cs('flex pointer-events-auto', flag ? 'p-3' : '')}>
        {flag && (
          <div
            className={cs('w-[164px] flex-shrink-0 rounded border bg-white mr-2')}
            style={{ height: flowFlodHeight, color: 'red' }}
          >
            <FlowFold />
          </div>
        )}
        <div className={cs('flex-1', flag ? '' : 'mx-[98px]')}>
          {showRecommendThemeList && (
            <LegacyRecommendThemeList generator={node.data} onClose={handleClosePromptGuide} />
          )}
          <LegacyPrompt generator={node.data} isFull from="primary" />
        </div>
      </div>
    );
  }
});
